var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-16"},[(_vm.title)?_c('h1',{staticClass:"font-semibold text-center h4",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),(_vm.subTitle)?_c('h2',{staticClass:"mt-5 font-normal text-center h5 text-grey-500",domProps:{"textContent":_vm._s(_vm.subTitle)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }